import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';

const FAQAccordion = ({ items }) => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <div className="space-y-4">
      {items.map((item, idx) => {
        const open = openIdx === idx;
        return (
          <div
            key={item.num}
            className={`rounded-2xl border transition-all duration-300 ${
              open
                ? 'bg-[#faf5fb] border-[#e870b6]/40 shadow-md'
                : 'bg-white border-slate-200 hover:border-[#f3d6f5]'
            }`}
          >
            <button
              className="w-full flex items-center gap-4 text-left px-5 py-5"
              onClick={() => setOpenIdx(open ? -1 : idx)}
            >
              <span
                className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-[14px] flex-shrink-0 ${
                  open ? 'bg-[#5b3eb5] text-white' : 'bg-[#f3d6f5] text-[#5b3eb5]'
                }`}
              >
                {item.num}
              </span>
              <span className="flex-1 font-semibold text-[16px] text-[#1a0b3d]">
                {item.question}
              </span>
              <ChevronRight
                size={20}
                className={`text-[#5b3eb5] transition-transform duration-300 ${
                  open ? 'rotate-90' : ''
                }`}
              />
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                open ? 'max-h-96' : 'max-h-0'
              }`}
            >
              <p className="px-5 pb-5 pl-[76px] text-slate-600 leading-relaxed text-[15px]">
                {item.answer}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FAQAccordion;
